import { Modal, Row } from "react-bootstrap"
import { Button, Input } from "../../../components"

const ModalForSlots = (props: any) => {
    const { show, handleClose, slotsList, setCurrentSlots, setOptionCourts, slot, setSlot } = props

    const handleChecked = (checked: boolean, data: any) => {
        checked
            ? setSlot([...slot, data])
            : setSlot(slot?.filter((item: any) => item.fromTime !== data.fromTime))
    }

    const handleAddSlots = () => {
        let slots = slot?.map((item: any) => ({
            startTime: item.fromTime,
            endTime: item.toTime,
        })
        )
        setOptionCourts([])
        setCurrentSlots(slots)
        handleClose()
    }

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter"
            centered show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Slot Selection</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="slot-selection">
                    <Row className="g-0">

                        <label htmlFor="" className="form-label">Available Slots</label>
                        <div className="available-slot d-flex flex-wrap gap-2">
                            {slotsList.length ? slotsList?.map((item: any, index: number) => {
                                return (
                                    <span style={{ width: '110px' }} key={"check" + index}>
                                        <Input onChange={(e: any) => handleChecked(e.target.checked, item)}
                                            checked={slot?.find((elem: any) => elem.fromTime === item.fromTime) ? true : false}
                                            id={"slot" + index} type="checkbox" name={"slot" + index} className="btn-check" />
                                        <label htmlFor={"slot" + index} className="bg-light bg-opacity-50 border border-2 btn btn-sm p-1 w-100">
                                            <div className="slot-box text-start">
                                                <span className="d-block">{item?.fromTime} to {item?.toTime}</span>
                                                <span className="text-primary"><span className="rupees-symbol">&#8377;</span> {item?.ratePerSlot}</span>
                                                {item?.discountPercent &&
                                                    <>
                                                        <del><span><span className="rupees-symbol">&#8377;</span> {item.actualRatePerSlot}</span></del>
                                                    </>
                                                }
                                            </div>
                                        </label>
                                    </span>
                                )
                            })
                                : <tr>
                                    <span className="text-danger">
                                        No Slots Available
                                    </span>
                                </tr>
                            }
                        </div>

                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" bname="Add" name="addslot" id="addslot" className="btn btn-primary rounded-1" onClick={handleAddSlots} ></Button>
            </Modal.Footer>
        </Modal>
    )
}

export { ModalForSlots }
